import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getPublicRoadmapURL = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.yola-public-roadmap.url');
  }

  return get(cfg, 'common.yola-public-roadmap.wl_url');
};

export default getPublicRoadmapURL;
